import { Box, Grid, Paper, Typography } from '@mui/material';
import { DisplayText, LineItem } from 'components';

export default function InPersonEventDetails({ inPersonEvent }) {
	return (
		<Paper style={{ minHeight: '70vh' }}>
			<Box padding={4}>
				<div>
					<Grid container>
						<Grid item xs={12}>
							<DisplayText
								label={'Short Description'}
								text={inPersonEvent.short_description}
							/>
						</Grid>
						<Grid item xs={12}>
							<DisplayText
								label={'Long Description'}
								text={inPersonEvent.description}
							/>
						</Grid>
						<Grid item xs={3}>
							<DisplayText
								label={'End Date:'}
								text={
									new Date(inPersonEvent.end_date).toLocaleDateString('en-GB') +
									' ' +
									new Date(inPersonEvent.end_date).toLocaleTimeString()
								}
							/>
						</Grid>
						<Grid item xs={2}>
							<DisplayText
								label={'Require Code'}
								text={inPersonEvent.is_private ? 'True' : 'False'}
							/>
						</Grid>
						<Grid item xs={3}>
							<DisplayText
								label={'Event Code'}
								text={inPersonEvent.event_code}
							/>
						</Grid>
						<Grid item xs={2}>
							<DisplayText label={'Event Type'} text={'In-person'} />
						</Grid>

						<Grid item xs={2}>
							<DisplayText
								label={'Published'}
								text={inPersonEvent.published ? 'True' : 'False'}
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body1">{'Event Image'}</Typography>
							<img src={inPersonEvent?.image_url} width={500} />
						</Grid>
					</Grid>
				</div>
			</Box>
		</Paper>
	);
}
